/**
 * Display-only sync window hints. Mirrors interval choices in
 * `apps/api/src/workers/syndication.worker.ts` scheduleMap (Facebook uses Meta hourly fetch).
 */
const SIX_H_MS = 6 * 60 * 60 * 1000;
const FOUR_H_MS = 4 * 60 * 60 * 1000;
const ONE_H_MS = 60 * 60 * 1000;

const INTERVAL_MS: Partial<Record<string, number>> = {
  CARGURUS: SIX_H_MS,
  AUTOTRADER: SIX_H_MS,
  GOOGLE_VEHICLES: FOUR_H_MS,
  CARS_COM: SIX_H_MS,
  TRUECAR: SIX_H_MS,
  OFFERUP: SIX_H_MS,
  EDMUNDS: SIX_H_MS,
  CARFAX: SIX_H_MS,
  KELLEY_BLUE_BOOK: SIX_H_MS,
  CRAIGSLIST_BULK: SIX_H_MS,
  /** Meta re-fetches the XML feed on an hourly schedule in typical setups */
  FACEBOOK: ONE_H_MS,
};

/**
 * Returns a short human string like "~4 hours" or "~1 hour" for reconnect toasts.
 */
export function formatApproxSyncWindow(platform: string): string {
  const ms = INTERVAL_MS[platform] ?? SIX_H_MS;
  if (ms === FOUR_H_MS) return '~4 hours';
  if (ms === ONE_H_MS) return '~1 hour';
  return '~6 hours';
}
